import { DebitCardColour } from '@npco/mp-gql-types'

export const CardTileColour = {
  ...DebitCardColour,
  // ...ExpenseCardColour,
}

export type CardTileColour = DebitCardColour
